/**
 * @generated SignedSource<<07638c00c305cf402b003d95c68ef841>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AcceptTermsInput = {
  personId?: string | null;
  termsVersionAccepted?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type AcceptTermsMutation$variables = {
  input: AcceptTermsInput;
};
export type AcceptTermsMutation$data = {
  readonly acceptTerms: {
    readonly viewer: {
      readonly actualPersonId: string | null;
      readonly hasAcceptedTerms: boolean | null;
    } | null;
  } | null;
};
export type AcceptTermsMutation = {
  variables: AcceptTermsMutation$variables;
  response: AcceptTermsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasAcceptedTerms",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AcceptTermsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AcceptTermsPayload",
        "kind": "LinkedField",
        "name": "acceptTerms",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AcceptTermsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AcceptTermsPayload",
        "kind": "LinkedField",
        "name": "acceptTerms",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2e4202c971e111bc24649c4342f42e2a",
    "id": null,
    "metadata": {},
    "name": "AcceptTermsMutation",
    "operationKind": "mutation",
    "text": "mutation AcceptTermsMutation(\n  $input: AcceptTermsInput!\n) {\n  acceptTerms(input: $input) {\n    viewer {\n      actualPersonId\n      hasAcceptedTerms\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3b115099a1698b4831aed2bc874c1816";

export default node;
